import { assign } from 'xstate5';

import { type CustomizationMachineAction } from '../../types';

// ─────────────────────────────────────────────────────────────────────────────

export const clearRequiredIngredientName: CustomizationMachineAction = assign({
  requiredIngredientName: undefined,
});
